@if (helpText || label) {
  <div class="mb-2 flex items-center gap-1">
    @if (label) {
      <mat-label class="text-sm font-medium">{{ label }}</mat-label>
    }
    @if (helpText) {
      <mat-icon
        class="material-icons-outlined hvs-icon-base cursor-help"
        [matTooltip]="helpText"
        matTooltipPosition="above"
        matTooltipClass="tooltip-above"
        >help_outline</mat-icon
      >
    }
  </div>
}
<mat-form-field
  *transloco="let t"
  class="datepicker__form_field w-full"
  [id]="id"
  appearance="outline"
  [subscriptSizing]="bottomMargin ? 'fixed' : 'dynamic'"
>
  <input
    matInput
    readonly
    class="datepicker__input"
    [matDatepicker]="datepicker"
    [min]="minDate"
    [max]="maxDate"
    [matDatepickerFilter]="dateFilter"
    [placeholder]="placeholder"
    [formControl]="control"
    (click)="datepicker.open()"
    (keydown.enter)="datepicker.open()"
  />
  <mat-icon
    matDatepickerToggleIcon
    matIconSuffix
    class="cursor-pointer text-base text-grey"
    (click)="datepicker.open()"
  >
    calendar_today
  </mat-icon>
  <mat-datepicker
    #datepicker
    [startView]="enableDaySelection ? 'month' : 'multi-year'"
    panelClass="datepicker__panel"
    (monthSelected)="!enableDaySelection && setMonthAndYear($event, datepicker)"
  >
  </mat-datepicker>
  @if (control.invalid && errorMessage() && !hideErrors) {
    <mat-error class="text-sm">
      {{ t('general.inputValidation.' + errorMessage()) }}
    </mat-error>
  }
</mat-form-field>
